import { useCallback, useEffect, useState } from 'react';

import { utils } from '@atlaskit/util-service-support/constants';
import type { RequestServiceOptions } from '@atlaskit/util-service-support/types';

import { DEFAULT_GRAPHQL_ENDPOINT } from '../../constants';

const SearchTenantContextQuery = `
  query SearchTenantContextQuery($cloudId: ID!) {
    tenantContexts(cloudIds: [$cloudId]) {
      cloudUrl
    }
	}
`;

interface SearchTenantContextVariables {
	cloudId: string;
}

interface TenantContext {
	cloudUrl?: string;
}

interface SearchTenantContextResponse {
	data?: {
		tenantContexts?: TenantContext[];
	};
}

const fetchTenantContext = (
	variables: SearchTenantContextVariables,
): Promise<SearchTenantContextResponse> => {
	const options: RequestServiceOptions = {
		requestInit: {
			method: 'POST',
			headers: {
				'Content-Type': 'application/json',
			},
			body: JSON.stringify({
				query: SearchTenantContextQuery,
				variables,
			}),
		},
	};

	return utils.requestService<SearchTenantContextResponse>(
		{ url: DEFAULT_GRAPHQL_ENDPOINT },
		options,
	);
};

export const useTenantContext: (cloudId: string) => {
	tenantContext: TenantContext;
	hasError: boolean;
} = (cloudId: string) => {
	const [tenantContext, setTenantContext] = useState<TenantContext>({});
	const [hasError, setHasError] = useState(false);

	const fetchContext = useCallback(async () => {
		try {
			const { data } = await fetchTenantContext({ cloudId });

			if (data?.tenantContexts && data.tenantContexts.length > 0) {
				setTenantContext(data.tenantContexts[0]);
			} else {
				setHasError(true);
			}
		} catch (e) {
			setHasError(true);
		}
	}, [cloudId]);

	useEffect(() => {
		fetchContext();
	}, [fetchContext]);

	return { tenantContext, hasError };
};
